export default {
  infoList: [
    {
      icon: 'androidsend',
      title: '插件、主页投稿',
      subtitle: '',
      content: '如果你是开发者，想获取注册邀请码或投稿主页，可以通过以下方式联系我：微信公众号: via插件 或 QQ：2214962083（备注投稿）'
    },
    {
      icon: 'iconfontweixin',
      title: '公众号',
      subtitle: '',
      content: '微信公众号搜索 via插件'
    },
    {
      icon: 'iosbook',
      title: '更新日志',
      subtitle: '',
      content: '2018年3月第一版，2019年9月重构归来上线。非常感谢曾经帮过我的酷友，还有一直支持的酷友，谢谢你们。'
    },
    {
      icon: 'socialgithub',
      title: '致谢',
      subtitle: '排名不分先后',
      content: ''
    }
  ],
  thanks: {
    indexList: [
      '开发',
      '赞助',
      '感谢',
      '友链'
    ],
    items: [
      {
        title: '开发组',
        index: '开发',
        persons: [
          {
            name: '谷花泰(我，滑稽)',
            link: 'https://space.bilibili.com/83540912'
          },
          {
            name: '酷安薛定谔的用户名',
            link: 'coolmarket://u/703542'
          },
          {
            name: 'via浏览器作者@various',
            link: 'coolmarket://u/441319'
          }
        ]
      },
      {
        title: '赞助组',
        index: '赞助',
        persons: [
          {
            name: '酷安七狗子',
            link: 'coolmarket://u/520656'
          },
          {
            name: '所有帮助过我的人',
            link: ''
          }
        ]
      },
      {
        title: '感谢',
        index: '感谢',
        persons: [
          {
            name: '酷安七狗子',
            link: 'coolmarket://u/520656'
          },
          {
            name: '宸浠',
            link: 'coolmarket://u/712085'
          },
          {
            name: '酷安荒野大瞟客',
            link: 'coolmarket://u/444673'
          },
          {
            name: '酷安Aynamic',
            link: 'coolmarket://u/567582'
          },
          {
            name: 'Ellis Wong',
            link: ''
          },
          {
            name: 'linmii',
            link: ''
          }
        ]
      },
      {
        title: '友情链接',
        index: '友链',
        persons: [
          {
            name: '七狗子的博客',
            link: 'https://www.bigblog.cn/'
          },
          {
            name: '谷花泰的酷安',
            link: 'coolmarket://u/486230'
          },
          {
            name: '谷花泰的哔哩哔哩',
            link: 'https://space.bilibili.com/83540912'
          },
          {
            name: 'via浏览器官网',
            link: 'http://viayoo.com/zh-cn/'
          }
        ]
      }
    ]
  }
}
